// src/utils/createUserProfile.js
// Create user profile document in Firestore for existing Firebase Auth user

import { doc, setDoc, getDoc } from 'firebase/firestore';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../config/firebase';

export const createUserProfileForExistingUser = async (email, password) => {
  try {
    console.log('🔐 Signing in to get user UID...');
    
    // Sign in to get the user UID
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    console.log('✅ User signed in, UID:', user.uid);
    
    // Check if user profile already exists
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      console.log('✅ User profile already exists:', userDoc.data());
      return { success: true, message: 'User profile already exists', profile: userDoc.data() };
    }
    
    // Create user profile document
    const userProfile = {
      uid: user.uid,
      email: user.email,
      name: 'Chris Heale',
      role: 'super_admin', // Set as super admin since you mentioned you used to be one
      createdAt: new Date(),
      updatedAt: new Date(),
      permissions: [
        'admin_access',
        'super_admin_access',
        'tenant_management',
        'user_management'
      ],
      settings: {
        theme: 'system',
        notifications: true,
        language: 'en'
      }
    };
    
    console.log('📝 Creating user profile document...');
    await setDoc(userDocRef, userProfile);
    
    console.log('🎉 User profile created successfully!');
    return { 
      success: true, 
      message: 'User profile created successfully', 
      profile: userProfile 
    };
    
  } catch (error) {
    console.error('❌ Error creating user profile:', error);
    return { 
      success: false, 
      error: error.message 
    };
  }
};

// Browser console function
window.createUserProfile = () => createUserProfileForExistingUser('christheale@gmail.com', 'Matrix=12');
